export default __webpack_public_path__ + "static/weare-2-4764bf058e8d873366723d1667126a3d.png";